module.exports = __webpack_public_path__ + "static/media/image-card-5.4786786d.png";